import TSAbstractEntity from './TSAbstractEntity';
import TSGemeinde from './TSGemeinde';
import {TSSerializable} from './TSSerializable';

export default class TSSchadenfallDaten extends TSAbstractEntity implements TSSerializable<TSSchadenfallDaten> {

    private _titel: string;

    private _gemeinde: TSGemeinde | undefined;

    public get titel(): string {
        return this._titel;
    }

    public set titel(value: string) {
        this._titel = value;
    }

    public get gemeinde(): TSGemeinde | undefined {
        return this._gemeinde;
    }

    public set gemeinde(value: TSGemeinde| undefined) {
        this._gemeinde = value;
    }

    deserialize(restObject: any): TSSchadenfallDaten {
        super.deserialize(restObject);

        this.titel = restObject.titel;
        this.gemeinde = this.deserializeOrNull(restObject.gemeinde, new TSGemeinde());
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.titel = this.titel;
        restObject.gemeinde = this.serializeOrInit(this.gemeinde, restObject.gemeinde);

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSSchadenfallDaten.ts